<template>
  <div class="enroll-statistic">
    <div class="content-wrapper">
      <div class="flex-wrapper1">
        <section class="item1">
          <p class="title">{{$t("m.sta_b_ydjsje")}}<span class="text">{{$t("m.sta_b_period")}}</span></p>
          <div class="flex-in">
            <div class="in-item">
              <p class="in-title">{{$t("m.sta_b_yjzsr")}}</p>
              <p class="price">{{totalpays}}</p>
            </div>
            <div class="in-item">
              <p class="in-title">{{$t("m.sta_b_ktx")}}
                <!--<span class="get">{{$t("m.sta_b_sqtx")}}</span></p>-->
              <p class="price">{{withdrawcash}}</p>
            </div>
          </div>
        </section>
        <section class="item2">
          <p class="title">{{$t("m.sta_b_ljtxje")}}</p>
          <div class="in-item">
            <p class="in-title">{{$t("m.sta_b_zje")}}
              <!--<span class="get">{{$t("m.sta_b_cktxjl")}}</span></p>-->
            <p class="price">{{hadwithdrawcash}}</p>
          </div>
        </section>
      </div>
      <div class="flex-wrapper2">
        <section class="item3">
          <p class="title">{{$t("m.sta_b_wdzh")}}</p>
          <div class="bind" v-if="bindShow===0">
            <p class="row">
              <span class="text">{{$t("m.sta_b_bdzfb")}}</span>
              <input type="text"
                     v-model="aliAccount"
                     class="input"
                     :placeholder="$t('m.sta_b_srzfb')">
            </p>
            <p class="row">
              <span class="text">{{$t("m.sta_b_xmzfb")}}</span>
              <input type="text"
                     v-model="aliName"
                     class="input"
                     :placeholder="$t('m.sta_b_srzfbxm')">
            </p>
            <p>
              <button class="btn" @click="UpdateRoomInfo(1)">{{$t("m.sta_b_msbd")}}</button>
              <span class="hint" @click="bindShow=1">{{$t("m.sta_b_bdwxzh")}}</span>
            </p>
          </div>
          <div class="bind" v-if="bindShow===1">
            <p class="row">
              <span class="text">{{$t("m.sta_b_bdwx")}}</span>
              <input type="text"
                     v-model="wechatAccount"
                     class="input"
                     :placeholder="$t('m.sta_b_srwx')">
            </p>
            <p class="row">
              <span class="text">{{$t("m.sta_b_xmwx")}}</span>
              <input type="text"
                     v-model="wechatName"
                     class="input"
                     :placeholder="$t('m.sta_b_srzfbxm')">
            </p>
            <p>
              <button class="btn" @click="UpdateRoomInfo(2)">{{$t("m.sta_b_msbd")}}</button>
              <span class="hint" @click="bindShow=0">{{$t("m.sta_b_bdzfbzh")}}</span>
            </p>
          </div>
          <div class="bind" v-if="bindShow===2">
            <p class="row" v-if="roomInfo.withdraw_alipayaccount">
              <span class="text">{{$t("m.sta_b_aliaccount")}}</span>
              <span class="text">{{roomInfo.withdraw_alipayaccount}}</span>
            </p>
            <p class="row" v-if="roomInfo.withdraw_wxaccount">
              <span class="text">{{$t("m.sta_b_wechatccount")}}</span>
              <span class="text">{{roomInfo.withdraw_wxaccount}}</span>
            </p>
            <div class="btn" @click="bindShow=0">{{$t("m.sta_b_xgbd")}}</div>
          </div>
        </section>
        <section class="item4">
          <p class="title">{{$t("m.sta_b_explain1")}}</p>
          <ul>
            <li class="list">
              {{$t("m.sta_b_explain2")}}
            </li>
            <li class="list">
              {{$t("m.sta_b_explain3")}}
            </li>
          </ul>
        </section>
      </div>
      <!--<div class="table-wrapper">-->
        <!--<p class="title">{{$t("m.sta_b_jsjlcx")}}</p>-->
        <!--<div class="ratio-wrapper">-->
          <!--<el-radio-group v-model="radioSelect" @change="changeItem">-->
            <!--<el-radio :label="$t('m.sta_b_zzsk')" selected @click.native="classfinish=1"></el-radio>-->
            <!--<el-radio :label="$t('m.sta_b_yjs')" @click.native="classfinish=2"></el-radio>-->
          <!--</el-radio-group>-->
        <!--</div>-->
        <!--<table class="table">-->
          <!--<tr>-->
            <!--<th class="th1">{{$t("m.sta_b_bjxx")}}</th>-->
            <!--<th class="th2">{{$t("m.sta_b_xxrs")}}</th>-->
            <!--<th class="th3">{{$t("m.sta_b_sksj")}}</th>-->
            <!--<th class="th4">{{$t("m.sta_b_yjsr")}}</th>-->
            <!--<th class="th5">{{$t("m.sta_b_dqskjd")}}</th>-->
            <!--<th class="th6">{{$t("m.sta_b_dqjsje")}}</th>-->
          <!--</tr>-->
          <!--<template v-for="(item,index) in classList">-->
            <!--<tr>-->
              <!--<td class="td1">-->
                <!--<div class="tdcontent-wrapper">-->
                  <!--<p class="line1">【{{decodeURIComponent(item.classmodename)}}】</p>-->
                  <!--<p class="line2">《{{decodeURIComponent(item.classname)}}》</p>-->
                <!--</div>-->

              <!--</td>-->
              <!--<td class="td2">{{item.enrollnums}}</td>-->
              <!--<td class="td3">{{item.startdate}}~{{item.enddate}}</td>-->
              <!--<td class="td4">{{item.estimateincome}}</td>-->
              <!--<td class="td5">{{$t("m.sta_b_ywc")}} {{item.finishedclassnums}} {{$t("m.sta_b_times")}}</td>-->
              <!--<td class="td6">-->
                <!--<div class="tdcontent-wrapper">-->
                  <!--<p class="line1">{{item.gotincome}}</p>-->
                  <!--&lt;!&ndash;<p class="line2">{{$t("m.sta_b_ckxx")}}</p>&ndash;&gt;-->
                <!--</div>-->
              <!--</td>-->
            <!--</tr>-->
          <!--</template>-->
        <!--</table>-->
        <!--<template v-if="totoalPage>10">-->
          <!--<el-pagination-->
            <!--background-->
            <!--layout="prev, pager, next"-->
            <!--:current-page.sync="currentPage"-->
            <!--@current-change="handleCurrentChange"-->
            <!--:page-size="10"-->
            <!--:total="totoalPage">-->
          <!--</el-pagination>-->
        <!--</template>-->
      <!--</div>-->
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        radioSelect: '正在上课的班级',
        //网校收入
        totalpays: '',          //收入总额
        withdrawcash:'',        //可提现金额
        hadwithdrawcash:'',     //已提现金额
        //--根据bindShow显示对应的页面，0显示绑定支付宝，1显示绑定微信，2显示绑定的界面--//
        bindShow: 0,
        aliAccount: '',
        aliName: '',
        wechatAccount: '',
        wechatName: '',
        roomInfo: {},
        //---------------班级列表及翻页-----------------------//
        classfinish: 1,
        currentLesson: null,
        currentPage: 1,
        totoalPage: 1,
        classList: [],                   //从服务端获取到的班级列表（总）
      }
    },
    methods: {
      changeItem(){
        let params = this.conputeXHRParams(1);
        this.queryClass(params);
      },
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber){
        let params = {
          c: 'Lesson',
          a: 'QueryClass',
          id: this.id,
          rid: this.schoolNow.rid,
          pageno: pageNumber,
          classfinish: this.classfinish,
          pagesize: 10,
          count: 1
        };
        return params;
      },
      //获取课程表列表
      queryClass(params){
        this.classList = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classList = response.list;
            this.totoalPage = response.recordcount;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //当页面发生改变时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(1);
        this.queryClass(params);
      },
      RoomInfoByRid(){
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'RoomInfoByRid',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list[0];
            this.totalpays = list.totalpays;
            this.withdrawcash =list.withdrawcash ;
            this.hadwithdrawcash=list.hadwithdrawcash;
            this.roomInfo = list;
            //如果用户没有绑定支付宝且没有绑定微信
            if ((list.withdraw_wxaccount === '') && (list.withdraw_alipayaccount === '')) {
              this.bindShow = 0;
            } else {
              this.bindShow = 2;
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      UpdateRoomInfo(num){
        //num==1表示通过支付宝，num==2表示用过微信
        let params;
        if (num === 1) {
          if (this.aliAccount === '') {
            this.$message({
              message: '请输入支付宝账号',
              type: 'warning'
            });
            return;
          }
          if (this.aliName === '') {
            this.$message({
              message: '请输入支付宝账号姓名',
              type: 'warning'
            });
            return;
          }
          params = {
            c: 'Room',
            a: 'UpdateRoomInfo',
            id: this.id,
            rid: this.schoolNow.rid,
            withdraw_alipayaccount: this.aliAccount,
            withdraw_alipayaccountname: this.aliName,
          };
        } else {
          if (this.wechatAccount === '') {
            this.$message({
              message: '请输入微信账号',
              type: 'warning'
            });
            return;
          }
          if (this.wechatName === '') {
            this.$message({
              message: '请输入微信账号姓名',
              type: 'warning'
            });
            return;
          }
          params = {
            c: 'Room',
            a: 'UpdateRoomInfo',
            id: this.id,
            rid: this.schoolNow.rid,
            withdraw_wxaccount: this.wechatAccount,
            withdraw_wxaccountname: this.wechatName,
          };
        }

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.RoomInfoByRid();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
    },
    created(){
      //根据当前选择的语言，设置radioSelect的默认选中项
      let language = loadLocal('language', false);
      if (language !== false) {
        if (language === 'en') {
          this.radioSelect = 'Ongoing Class';
          this.$i18n.locale = 'en-US';
        } else {
          this.radioSelect = '正在上课的班级';
          this.$i18n.locale = 'zh-CN';
        }
      }
      // let params = this.conputeXHRParams(1);
      // this.queryClass(params);
      //获取用户网校绑定的支付宝账号
      this.RoomInfoByRid();
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .enroll-statistic
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      min-width: 1166px
      .flex-wrapper1
        display: flex
        .item1
          flex: 2
          margin-right: 20px
          background: #fff
          .title
            font-size: 15px
            color: #555555
            font-weight: bold
            height: 49px
            line-height: 49px
            text-indent 38px
            border-bottom: 1px solid #e4e4e4
            background: #fff url('./icon.png') no-repeat left 10px center / 18px 18px
            .text
              font-size: 14px
              color: #999

          .flex-in
            height: 192px
            display: flex
            .in-item
              flex: 1
              text-align: center
              .in-title
                margin: 50px 0 20px
                font-size: 16px
                color: #000000
                position relative
                .get
                  color: #3399ff
                  font-size: 16px
                  cursor: pointer

              .price
                height: 34px
                font-size: 24px
                color: #ff6666
                font-weight: bold

        .item2
          flex: 1
          background: #fff
          .title
            text-indent 38px
            font-size: 15px
            color: #555555
            font-weight: bold
            height: 49px
            line-height: 49px
            border-bottom: 1px solid #e4e4e4
            background: #fff url('./icon.png') no-repeat left 10px center / 18px 18px
          .in-item
            text-align: center
            .in-title
              margin: 50px 0 20px
              font-size: 16px
              color: #000000
              position relative
              .get
                color: #3399ff
                font-size: 16px
                position: absolute
                cursor: pointer
                left: calc(50% + 50px)
            .price
              height: 34px
              font-size: 24px
              color: #ff6666
              font-weight: bold
      .flex-wrapper2
        display: flex
        margin-top: 20px
        .item3
          flex: 1
          margin-right: 20px
          background: #fff
          .title
            text-indent 38px
            font-size: 15px
            color: #555555
            font-weight: bold
            height: 49px
            line-height: 49px
            border-bottom: 1px solid #e4e4e4
            background: #fff url('./icon.png') no-repeat left 10px center / 18px 18px
          .bind
            padding: 10px 0 0 60px
            height: 66px
            .row
              margin-bottom: 6px
              .text
                display: inline-block
                font-size: 16px
                color: #000000
                line-height: 30px
                width: 150px
              .input
                height: 28px
                background: #fafafa
                border: 1px solid #d7d7d7
                border-radius: 4px
                font-size: 16px
                color: #000000
                padding-left: 10px
                &::-webkit-input-placeholder
                  color: #ccc
            .btn
              margin-top: 4px
              height: 26px
              width: 74px
              color: #ffffff
              font-size: 14px
              line-height: 26px
              background: #3399ff
              text-align: center
              border-radius 4px
              cursor: pointer
            .hint
              margin-left: 10px
              font-size: 12px
              color: #999
              cursor: pointer

        .item4
          flex: 1
          height: 170px
          background #fff
          padding: 20px 30px 25px
          box-sizing border-box
          .title
            font-size: 16px
            color: #000000
            line-height: 20px
            margin-bottom: 10px
          .list
            font-size: 13px
            color: #888888
            line-height: 19px

      .table-wrapper
        margin-top: 20px
        padding: 20px 20px 20px
        background #fff
        position relative
        .title
          font-size: 20px
          color: #000000
          line-height: 28px
          margin-bottom: 26px
        .ratio-wrapper
          position absolute
          right: 20px
          top: 22px

        .table
          width: 100%
          table-layout fixed
          th
            height: 42px
            line-height: 42px
            font-size: 14px
            color: #666
            background #e4e4e4
            box-sizing: border-box
          .th1
            width: 26%
          .th2
            width: 13%
          .th3
            width: 22%
          .th4
            width: 13%
          .th5
            width: 13%
          .th6
            width: 13%
          tr
            td
              height: 80px
              border: 1px solid #e4e4e4
            .td2, .td3, .td4, .td5
              vertical-align: middle
              text-align center
              font-size: 14px
              color: #333
            .td1
              padding-left: 10px
              vertical-align: middle
              .tdcontent-wrapper
                display: inline-block
                vertical-align: middle
                .line1
                  height: 22px
                  line-height: 22px
                  font-size: 16px
                  color: #000000
                  font-weight: bold
                .line2
                  height: 20px
                  line-height: 20px
                  font-size: 14px
                  color: #666666

            .td6
              vertical-align: middle
              text-align center
              .tdcontent-wrapper
                display: inline-block
                vertical-align: middle
              .line1, .line2
                height: 20px
                line-height: 20px
                font-size: 14px
                color: #333
              .line2
                color: #3399ff
                cursor pointer
</style>



// WEBPACK FOOTER //
// src/page/statistic/enrollstatistic/EnrollStatistic.vue